
export class TextTexture {
    url = '';
    width = 0;
    height = 0;
    constructor(data) {
    //   data= {
    //     text: '1~ewqrqwr4',
    //     fontSize: 20,
    //     color: 'green',
    //     padding: 10,
    // backgroundColor
    //     border: {
    //       width: 3,
    //       color: 'blue',
    //     }
    //   };
      const { url, tW, tH } = this.getTextCanvas(data);
      this.url = url;
      this.width = tW;
      this.height = tH;
    }
    getTextureUrl() {
      return this.url;
    }
    getTextSize() {
      return {
        width: this.width,
        height: this.height,
      };
    }
    // 创建文本canvas
    getTextCanvas(options) {
      const border = options?.border ?? {};
      const padding = (options?.padding ?? 10) + (border?.width ?? 0) * 2;
      const text = options?.text ?? '';
      const bgc = options?.backgroundColor ?? '';
      // console.log('bgc', bgc);
      const fontSize = options?.fontSize;
      const tH = fontSize + 2 * padding;
      // 用canvas生成图片
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      context.font = `normal ${fontSize}px Arial`;
      // 绘制文字
      const measureText = context.measureText(text);
      let tW = (measureText.width || 0) + 2 * padding;
      // console.log(tW, tH);
      tW = tW > tH ? tW : tH;
      canvas.width = tW;
      canvas.height = tH;
      this.creatTextBorder(context, tW, tH, options.border, bgc);
      context.font = `normal ${fontSize}px Arial`;
      context.textAlign = 'center';
      context.textBaseline = 'middle';
      context.fillStyle = options.color;
      context.fillText(text, tW / 2, tH / 2);
      context.restore();

      // 生成图片
      const url = canvas.toDataURL('image/png');
      canvas.remove();
      // console.log(tW, tH, 'text url ===', url);
      return { url, tW, tH };
    }
    // 绘制文本边框
    creatTextBorder(ctx, tW, tH, border, bgc) {
      ctx.save();
      ctx.beginPath();
      ctx.fillStyle = bgc;
      const boderW = border.width;
      const radius = tH / 2 - boderW;
      // 左半圆
      ctx.arc(radius + boderW, tH / 2, radius, Math.PI / 2, Math.PI * 3 / 2);
      // 连线
      ctx.lineTo(tW - radius - boderW, boderW);
      // 右右圆
      ctx.arc(tW - radius - boderW, tH / 2, radius, Math.PI * 3 / 2, Math.PI / 2);
      ctx.lineTo(radius + boderW, tH - boderW);
      ctx.closePath();
      ctx.lineWidth = boderW;
      ctx.strokeStyle = border.color;
      ctx.fill(); // 填充
      ctx.stroke();// 画空心圆
      ctx.restore();
    }
}
